<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="departments"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a user department
     */
    export default {
        name: 'ies-adminDepartmentKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                departments: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getDepartments();
        },
        methods: {
            getDepartments:function(){
                axios.get('/api/admin-departments')
                .then(function(response){
                    var departments = [{text: "Not Set", value: ""}];
                    response.data.forEach(function(record){
                        departments.push({ text: record.name, value: record.admin_user_department_key });
                    });
                    this.departments = departments;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
